import React from 'react';
import CategoryMenuContainer from './CategoryMenuContainer';
import styled from 'react-emotion';
import posed from 'react-pose';
import theme from '@jetshop/ui/utils/theme';

const Nav = styled('nav')`
  background: transparent;
  width: 100%;
  button {
    background: none;
    color: #777;
  }

  a[href$='rea'] {
    color: #ff0000 !important;
  }
  a[href$='julklappstips'] {
    color: #ff0000 !important;
  }
  a[href$='julklappstips-1'] {
    color: #ff0000 !important;
  }
`;

const PosedMenuContainer = styled(
  posed('div')({
    enter: {
      marginTop: 0,
      transition: {
        duration: 200,
        ease: 'linear',
      },
    },
    exit: {
      marginTop: '-50px',
      transition: {
        duration: 1500,
        ease: 'linear',
      },
    },
  })
)``;

export function CategoryMenu({ data }) {
  return (
    <Nav>
      <PosedMenuContainer key={'menuContainerPosed'}>
        <CategoryMenuContainer queryData={data} />
      </PosedMenuContainer>
    </Nav>
  );
}
